import DataEntry from './DataEntry';
import SecureArea from './SecureArea';

export default class DataFile extends DataEntry {
    createMarkup() {
        // this.$html = `
        //     <li>
        //         <a href="#" data-type="${this.entry.type}" data-id="${this.id}" data-extension="${this.entry.extension}">
        //         <i class="fa fa-file-o"></i> <span>${this.entry.title}</span></a>
        //     </li>
        // `;

        this.$li = document.createElement('li');
        
        this.$link = document.createElement('a');
        this.$link.setAttribute('href', "#");
        this.$link.setAttribute('data-id', this.id);
        this.$link.setAttribute('data-extension', this.entry.extension.toLowerCase());
        this.$link.setAttribute('data-type', "file");
        
        this.$fa = document.createElement('i');
        this.$fa.classList.add('fa', 'fa-file-o');
        
        this.$span = document.createElement('span');
        this.$span.innerText = this.entry.title;
        
        this.$link.appendChild(this.$fa);
        this.$link.appendChild(this.$span);
        this.$li.appendChild(this.$link);
        this.$html = this.$li;

    }

    setClickEvent() {
        if ((this.permissions & 1) == 1) {
            this.$link.on('click', (e) => {
                e.preventDefault();

                let that = this;
                
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: dataUrl,
                    data: {
                        "action": dataActionPrefix + "read",
                        "fileId": that.id
                    },
                    beforeSend: () => {
                        securearea.addSpinner();
                        that.disableEntry();
                    },
                    complete: () => {
                        securearea.removeSpinner();
                        that.enableEntry();
                    },
                    error: (jqXHR, textStatus, errorThrown ) => {
                        console.log(jqXHR, textStatus, errorThrown );
                    },
                    success: (json) => {
                        $('.errormsg').remove();

                        if (json.success) {
                            window.location.href = json.data.downloadUrl;
                        } else {
                            securearea.showError("read", json);
                            return false;
                        }
                    }
                });
            });
        }
    }
}


/** WEBPACK FOOTER **
 ** ./Frontend/js/modules/securearea-next/classes/DataFile.js
 **/